import { ThemeColor } from '@/enums'
import { CheckLine } from '@/icons'
import { Typography } from '../../atoms'
import {
  BreadcrumbBorder,
  BreadcrumbText,
  BreadcrumbsContainer,
  Step,
} from './styles'
import { JSX } from 'react'

interface BreadcrumbsProps {
  steps: number[] | string[]
  current: number
  stepperBreadcrumbTitles: Record<string, string> | string[]
}

export const Breadcrumbs = ({
  steps,
  current,
  stepperBreadcrumbTitles,
}: BreadcrumbsProps): JSX.Element => (
  <BreadcrumbsContainer>
    {steps.map((step, i) => {
      const stepNumber = typeof step === 'string' ? parseInt(step, 10) : step
      return (
        <Step key={i} current={current === i} done={current > i}>
          <BreadcrumbBorder current={current === i} checked={current > i}>
            <Typography
              color={current === i ? ThemeColor.electric500 : ThemeColor.b50}
              variant="captionR"
            >
              {current > i ? (
                <CheckLine color={ThemeColor.b0} size={20} />
              ) : (
                stepNumber + 1
              )}
            </Typography>
          </BreadcrumbBorder>
          <BreadcrumbText current={current === i} done={current > i}>
            {Array.isArray(stepperBreadcrumbTitles)
              ? stepperBreadcrumbTitles[stepNumber]
              : stepperBreadcrumbTitles[stepNumber.toString()]}
          </BreadcrumbText>
        </Step>
      )
    })}
  </BreadcrumbsContainer>
)
